module.exports = __webpack_public_path__ + "static/media/music-icon.01fa84bf.svg";